export async function performPollingWithRetry(
  pollingFunction: () => Promise<boolean>,
  retryCount: number,
  delayMs: number,
) {
  for (let i = 0; i < retryCount; i++) {
    try {
      const result = await pollingFunction(); // Выполняем функцию поллинга и получаем результат

      if (result) {
        return; // Успешно завершили поллинг, выходим из цикла
      }

      // Если результат false, продолжаем и переходим к задержке
      if (i < retryCount - 1) {
        await new Promise(resolve => setTimeout(resolve, delayMs)); // Задержка перед следующей попыткой
      }
    } catch (error) {
      if (i < retryCount - 1) {
        await new Promise(resolve => setTimeout(resolve, delayMs)); // Задержка перед следующей попыткой
      }
    }
  }

  throw new Error('Maximum polling attempts reached'); // Ошибка после достижения максимального числа попыток
}
